import React from 'react'
import { useFormContext } from 'react-hook-form'
import { isEmpty } from 'lodash'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Link,
  Typography,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { ChevronDown as ChevronDownIcon } from 'react-feather'

import { ConsentDefaultSignalRow } from './components'

import constants from 'constants/index'
import useStyles from './styles'

// "A", "A e B", "A, B e C"
const joinNames = (names) =>
  names.length > 1
    ? `${names.slice(0, -1).join(', ')} e ${names[names.length - 1]}`
    : names[0]

const ConsentDefaultSettings = () => {
  const { watch } = useFormContext()

  const classes = useStyles()

  const {
    CONSENT_DEFAULT_GRANTED,
    CONSENT_DEFAULT_ROWS,
    CONSENT_MODE_DESCRIPTION,
    CONSENT_MODE_TITLE,
  } = constants.cookies.category
  const { LINK_DOCUMENTATION_TAG_MANAGER } = constants.cookies.banner

  const grantedRows = CONSENT_DEFAULT_ROWS.filter(
    (category) =>
      watch(`consentDefaultSignals.${category.key}`) ===
      CONSENT_DEFAULT_GRANTED,
  )
  // Recolhido, o card mostra o valor escolhido sem precisar abrir
  const summary = isEmpty(grantedRows)
    ? 'tudo negado até o visitante escolher'
    : `concedido para ${joinNames(grantedRows.map(({ name }) => name))}`

  return (
    <Accordion variant="outlined" className={classes.accordion}>
      <AccordionSummary
        id="consent-mode-settings-header"
        aria-controls="consent-mode-settings"
        expandIcon={<ChevronDownIcon size={20} />}
      >
        <Box>
          <Typography color="primary" variant="h5" component="span">
            {CONSENT_MODE_TITLE}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            component="span"
            display="block"
          >
            Sinal inicial ao Google: {summary}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails id="consent-mode-settings" className={classes.content}>
        <Typography variant="body2" color="textSecondary">
          {CONSENT_MODE_DESCRIPTION}
        </Typography>
        {CONSENT_DEFAULT_ROWS.map((category) => (
          <ConsentDefaultSignalRow key={category.key} category={category} />
        ))}
        {/* Um quadro só: as notas das categorias concedidas e o aviso do modelo */}
        <Alert severity="info">
          <Box className={classes.notes}>
            {grantedRows.map((category) => (
              <Typography key={category.key} variant="body2">
                <strong>{category.name}:</strong> {category.grantedNote}
              </Typography>
            ))}
            <Typography variant="body2">
              Usa o nosso modelo do Google Tag Manager? O sinal inicial só é
              aplicado com o código do banner no HTML do site. Com o banner
              carregado por uma tag do Tag Manager, tudo começa negado até o
              visitante escolher.{' '}
              <Link
                href={LINK_DOCUMENTATION_TAG_MANAGER}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
              >
                Ver o guia
              </Link>
            </Typography>
          </Box>
        </Alert>
      </AccordionDetails>
    </Accordion>
  )
}

export default ConsentDefaultSettings
